import { useAppSelector } from "@/app/appStore";
import { selectSelectedEvent } from "@/entities/annotation";
import { getEventDetails } from "../annotation-types/mappings/event-details-mapping";

export const AnnotationEventDetails: React.FC = () => {
  const selectedEvent = useAppSelector(selectSelectedEvent);

  if (!selectedEvent) return null;
  const EventDetailsComponent = getEventDetails(selectedEvent.type);

  return <EventDetailsComponent />;
};
